import { BUTTON } from 'react-toolbox/lib/identifiers';
import { themr } from 'react-css-themr';
import { iconButtonFactory } from './IconButton';
import FontIcon from 'react-toolbox/lib/font_icon/FontIcon';
import themedRippleFactory from 'react-toolbox/lib/ripple';
import theme from 'react-toolbox/lib/button/theme.scss';
import countTheme from './IconButton.scss';
import Button, { ButtonTypes } from './Button';
import AddButton from './AddButton';
import DownloadButton from './DownloadButton';
import { ButtonWithPopover } from './ButtonWithPopover';
import { ButtonWithPopoverList } from './ButtonWithPopoverList';
import { linkFactory } from 'common/components/core/link';
import Tooltip from 'common/components/core/tooltip';
import { SplitButton } from './SplitButton';
import popOverFactory from 'common/components/core/popover/popOverFactory';
import SortButton from './SortButton';
import ClearButton from './ClearButton';
import FeedbackButton from './FeedbackButton';

const IconButton = iconButtonFactory(
    themedRippleFactory({ centered: true }),
    FontIcon
);

const IconButtonWithPopover = popOverFactory({ Component: IconButton });

const ThemedIconButton = themr(BUTTON, theme)(IconButton);

const CountThemedIconButton = themr(BUTTON, countTheme)(ThemedIconButton);

const LinkButton = linkFactory({ LinkedComponent: Button });

export const TooltipIconButton = Tooltip(ThemedIconButton);
export const TooltipCountIconButton = Tooltip(CountThemedIconButton);

export default Button;
export {
    Button,
    AddButton,
    CountThemedIconButton as CountIconButton,
    ThemedIconButton as IconButton,
    ButtonTypes,
    LinkButton,
    ButtonWithPopover,
    ButtonWithPopoverList,
    DownloadButton,
    SplitButton,
    IconButtonWithPopover,
    SortButton,
    ClearButton,
    FeedbackButton
};

/**
 * @deprecated Use @component ButtonWithPopovers with hover as trigger option instead
 */
export const TooltipButton = Tooltip(Button);
